import styled from "styled-components";

export const ReportUtilityButtonContainer = styled.div`
	z-index: 100;
	position: fixed;
	bottom: ${props => props.isTabletScreen ? '75px': 0};
	right: 0;
	padding: 10px;
`